import * as i from "react";
import { useLocalizationContext as s } from "./useUtils.mjs";
function d(n, c, a, u) {
  const {
    value: o,
    onError: r
  } = n, f = s(), e = i.useRef(u), t = c({
    adapter: f,
    value: o,
    props: n
  });
  return i.useEffect(() => {
    r && !a(t, e.current) && r(t, o), e.current = t;
  }, [a, r, e, t, o]), t;
}
export {
  d as useValidation
};
//# sourceMappingURL=useValidation.mjs.map
